module.exports = __webpack_public_path__ + "img/solar-user-icon.699a2f46.svg";